import React, { useState, useEffect } from 'react';
import { handleChange, handleSubmit } from "../../Controller/CreatePartController";
import DiscountTypeService from "../../../Setup/controller/StockCategoryController/StockCategoryController";
import UnitofMeasureService from "../../../Setup/controller/UnitOfMeasureController/UnitOfMeasureController";
import LocationService from "../../../Setup/controller/LocationController/LocationController";
import PartService from "../../Controller/PartController";
import { useNavigate, useLocation } from 'react-router-dom';
import HelpSite from "../../../Common/HelpLink";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import CurrencyTextField from "../../../Jobs/View/JobForms/CurrencyTextField";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import LeadUserDefineFieldsSection from './PartUserDefineSelection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";

import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from "../../../../config/config";
import Draggable from 'react-draggable';
import Cookies from "js-cookie";
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import { PDFDocument } from "pdf-lib";
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import { getMergedPDFBlob } from '../../../Common/ReportPDFService';
function CreatePart({ StockID, Tab, isLock, onClose }) {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        ID: 0,
        vc_StockCode: '',
        StockType: 1,
        snt_ItemType: 0,
        vc_Description: '',
        dec_UnitWeight: '0.000',
        dec_MinimumQuantity: '0',
        dec_MaximumQuantity: '999999999',
        mon_SalesPrice: '0.00',
        mon_StockPrice: '0.00',
        mon_LastPurchasePrice: '0.00',
        vc_UnitOfSale: '0',
        vc_Manufacturer: '',
        vc_Barcode: '',
        vc_ManufacturerCode: '',
        bit_BatchManagement: '0', // Change initial state to null
        dec_Density: '1.000',
        snt_SerialTracking: '0', // Change initial state to null
        FK_UnitOfMeasure_ID_Sales: '0',
        FK_UnitOfMeasure_ID_Purchasing: '0',
        ProductBuild: '0', // Change initial state to null
        dec_conversion: '',
        dec_MinimumQuantityDepot: '0.00',
        dec_MaximumQuantityDepot: '0.00'
    });
    const [unitOfMeasureList, setUnitOfMeasure] = useState([]);
    const [DiscountsList, setDiscounts] = useState([]);
    const [LocationList, setLocationData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [showBatchRadio, setShowBatchRadio] = useState(true);
    const [shoewSerialRadio, setShowSerialRadio] = useState(true);
    const [unitsAreSame, setUnitsAreSame] = useState(false);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [StockLocationList, setStockLocation] = useState([]);
    const [loading, setLoading] = useState(true);
    const [value, setValue] = useState('');
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [showPartMessage, setShowPartMessage] = useState(false);
    const [currencySymbol1, setCurrencySymbol1] = useState('');
    const [defCurreny, setCurrency] = useState(null);
    const [currencyValue1, setCurrencyValue1] = useState('');
    const [currencyCostSymbol1, setCostCurrencySymbol1] = useState('');
    const [currencyCostValue1, setCostCurrencyValue1] = useState('');
    const [BaseCurrency, setBaseCurrency] = useState('');
    const [currencyList, setCurrencies] = useState([]);
    const [KeyNameList, setKeyNames] = useState([]);

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");
    const [isChanged, setIsChanged] = useState(false);
    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const setSortConfigInCookie = (config) => {
        Cookies.set(`TeamSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`TeamSort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };



    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, StockID, "4");
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };

    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };
    const handleFieldChange = (event) => {
        setIsChanged(true);
        handleChange(event, formData, setFormData);

        // Check if Sale Unit and Purchase Unit are the same
        const { name, value } = event.target;
        let updatedFormData = { ...formData, [name]: value };

        if (name === 'FK_UnitOfMeasure_ID_Sales' || name === 'FK_UnitOfMeasure_ID_Purchasing') {
            const saleUnit = name === 'FK_UnitOfMeasure_ID_Sales' ? value : formData.FK_UnitOfMeasure_ID_Sales;
            const purchaseUnit = name === 'FK_UnitOfMeasure_ID_Purchasing' ? value : formData.FK_UnitOfMeasure_ID_Purchasing;
            const areUnitsSame = saleUnit === purchaseUnit;
            setUnitsAreSame(areUnitsSame);

            if (!areUnitsSame && updatedFormData.dec_conversion === '') {
                updatedFormData.dec_conversion = '1';
            }
        }


        if (name === 'dec_conversion') {
            // Check if the input is a valid decimal number
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_conversion = value;
            } else {
                // If the input is not a valid decimal number, reset the field to the previous value
                updatedFormData.dec_conversion = formData.dec_conversion || '';
            }
        }
        if (name === 'mon_StockPrice') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.mon_StockPrice = value;
            } else {

                updatedFormData.mon_StockPrice = formData.mon_StockPrice || '';
            }
        }
        if (name === 'dec_Density') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_Density = value;
            } else {

                updatedFormData.dec_Density = formData.dec_Density || '';
            }
        }
        if (name === 'mon_SalesPrice') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.mon_SalesPrice = value;
            } else {

                updatedFormData.mon_SalesPrice = formData.mon_SalesPrice || '';
            }
        }
        if (name === 'dec_UnitWeight') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_UnitWeight = value;
            } else {

                updatedFormData.dec_UnitWeight = formData.dec_UnitWeight || '';
            }
        }
        if (name === 'dec_MinimumQuantity') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_MinimumQuantity = value;
            } else {

                updatedFormData.dec_MinimumQuantity = formData.dec_MinimumQuantity || '';
            }
        }
        if (name === 'dec_MaximumQuantity') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_MaximumQuantity = value;
            } else {

                updatedFormData.dec_MaximumQuantity = formData.dec_MaximumQuantity || '';
            }
        }
        if (name === 'dec_Quantity') {
            // Allow optional + or - at the beginning, followed by digits only
            if (/^[+-]?\d*$/.test(value)) {
                updatedFormData.dec_Quantity = value;
            } else {
                updatedFormData.dec_Quantity = formData.dec_Quantity || '';
            }
        }
        if (name === 'dec_MaximumQuantityDepot') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_MaximumQuantityDepot = value;
            } else {

                updatedFormData.dec_MaximumQuantityDepot = formData.dec_MaximumQuantityDepot || '';
            }
        }
        if (name === 'dec_MinimumQuantityDepot') {
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_MinimumQuantityDepot = value;
            } else {

                updatedFormData.dec_MinimumQuantityDepot = formData.dec_MinimumQuantityDepot || '';
            }
        }

        if (name === "FK_UnitOfMeasure_ID_Sales") {
            if (value > 0) {
                const SelectedMeasurement = unitOfMeasureList.find(x => x.ID === parseInt(value));
                if (SelectedMeasurement.DecimalPlaces === 0) {
                    setShowSerialRadio(true);
                    setShowBatchRadio(false);

                }
                else {
                    setShowBatchRadio(true);
                    setShowSerialRadio(false);
                }
            }
            else {
                setShowBatchRadio(true);
                setShowSerialRadio(true);
            }
        }

        setFormData(updatedFormData);
    };

    useEffect(() => {
        const initializeData = async () => {
            fetchCurrency();
            await fetchDefaultCurrency();
            fetchDiscount();
            fetchUnitOfMeasure();
            fetchLocations();
            setTableData([]);
            if (StockID === 0) {
                resetForm();
                setStockLocation([]);
                setTableData([]);
                fetchKeyNames();
            } else {
                fetchPartDetail();
                fetchStockLocations("0", pageSize);
                fetchKeyNames();
            }
        };
        initializeData();
    }, [StockID, Tab]);
    useEffect(() => {
        fetchStockLocations(currentPage, pageSize);

    }, [currentPage, pageSize]);
    useEffect(() => {
        fetchStockLocations(currentPage, pageSize);

    }, [sortConfig]);
    useEffect(() => {
        if (StockLocationList.length > 0) {
            // Populate tableData only if StockLocationList has data
            setTableData(StockLocationList.map((location, index) => ({
                ID: location.PK_StockLocation_ID,
                Depots: location.FK_Location_ID,
                DepotName: location.vc_Name,
                Location: location.vc_BayName,
                Quantity: "0",
                Pending: location.dec_Quantity, // Set quantity to empty string for now
                dec_Allocated: location.dec_Allocated
            })));
            // Set loading to false when data is populated
            setLoading(false);
        }
    }, [StockLocationList, Tab]);
    const fetchDefaultCurrency = async () => {
        try {
            debugger;
            const redirectCallback = () => navigate('/');
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            setCurrency(listOfCurreny);
            setCurrencySymbol1(listOfCurreny[0].Symbol);
            setCurrencyValue1("0.00");
            setCostCurrencySymbol1(listOfCurreny[0].Symbol);
            setCostCurrencyValue1("0.00");
            setBaseCurrency(listOfCurreny[0].Symbol);

        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            setCurrencies(currencyData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchDiscount = async () => {
        try {
            const listOfDiscounts = await DiscountTypeService.GetAllStckCategories();
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };

    const fetchUnitOfMeasure = async () => {
        try {
            const listOfUnits = await UnitofMeasureService.GetAllUnitOfMeasure();
            setUnitOfMeasure(listOfUnits);
        } catch (error) {
            console.error('Error fetching units of measure:', error);
        }
    };

    const fetchLocations = async () => {
        try {
            const listOfLocations = await LocationService.GetAllLocations();
            setLocationData(listOfLocations);
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };
    const fetchStockLocations = async (page, size) => {
        try {
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();
            const PartID = StockID;

            const listOfLocations = await PartService.GetPartLocation(redirectCallback, PartID, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setStockLocation(listOfLocations);
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };
    const location = useLocation();
    const fetchPartDetail = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const PartID = StockID;

            if (PartID > 0) {
                const SupplierDetail = await PartService.GetPartByID(redirectCallback, PartID);

                const formattedDetail = {
                    ...SupplierDetail[0],
                    ProductBuild: String(SupplierDetail[0].ProductBuild), // Convert to string
                    snt_SerialTracking: String(SupplierDetail[0].snt_SerialTracking), // Convert to string
                    bit_BatchManagement: String(SupplierDetail[0].bit_BatchManagement), // Convert to string
                    dec_Quantity: "0",

                };

                setCostCurrencyValue1(SupplierDetail[0].mon_StockPrice);
                setCurrencyValue1(SupplierDetail[0].mon_SalesPrice);

                setFormData(prev => ({
                    ...prev,
                    ...formattedDetail
                }));
                // Handle radio button visibility based on initial values
                setShowBatchRadio(formattedDetail.snt_SerialTracking === "0");
                setShowSerialRadio(formattedDetail.bit_BatchManagement === "0");
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };


    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };

        const redirectUserList = () => {
            navigate('/PartList?saved=true');
        };

        formData.mon_StockPrice = currencyCostValue1;
        formData.mon_SalesPrice = currencyValue1;

        if (StockID === 0) {
            const StockCode = formData.vc_StockCode;
            const AlreadyExist = await PartService.PartAlreadyExist(redirectCallback, StockCode);
            if (AlreadyExist.length > 0) {
                setShowPartMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowPartMessage(false);
                }, 5000);
                return false;
            }
        }
        // Calculate the total quantity
        const sum = tableData.reduce((total, record) => total + parseFloat(record.Quantity), 0);
        const sum1 = tableData.reduce((total, record) => total + parseFloat(record.Pending), 0);
        const sum2 = parseFloat(sum) + parseFloat(sum1);
        setTotalQuantity(sum2);

        const SaleUnit = getUnitName(parseInt(formData.FK_UnitOfMeasure_ID_Sales));
        formData.SaleUnit = SaleUnit;
        formData.sum_Quantity = sum2;

        formData.dec_MinimumQuantityDepot = formData.dec_MinimumQuantity;
        formData.dec_MaximumQuantityDepot = formData.dec_MaximumQuantity;

        if (formData.PK_Stock_ID) {
            formData.ID = formData.PK_Stock_ID;
        }
        else {
            formData.ID = 0;
        }
        // Create the request payload

        const payload = {
            formData: formData,
            tableData: tableData
        };
        const message = await handleSubmit(event, payload, setFormData, setErrors, redirectCallback, redirectUserList);
        if (message == "Data saved successfully") {
            setIsChanged(false);
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
            localStorage.setItem('HasRecordUpdated', "1");
            setTableData([]);
            fetchPartDetail();
            fetchStockLocations("0", pageSize);
            redirectUserList();
            await handleUserDefineSubmit({
                JobID: StockID,
                fields: KeyNameList.map(key => ({
                    PK_KeyName_ID: key.PK_KeyName_ID,
                    value: formData[key.vc_Name] || ''
                }))
            });
            fetchKeyNames();
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }
    };

    const handleRadioChange = (event) => {
        const { name, value } = event.target;

        setFormData({
            ...formData,
            [name]: value
        });

        if (name === "snt_SerialTracking") {
            setShowBatchRadio(value === "0");
        }
        if (name === "bit_BatchManagement") {
            setShowSerialRadio(value === "0");
        }
    };

    const handleAddButtonClick = () => {
        debugger;
        if (!formData.FK_Location_ID || !formData.dec_Quantity) {
            // Show a validation error or alert
            Swal.fire(
                'Error!',
                'Please fill depots and Quantity.',
                'error'
            );
            return false; // Stop execution if any field is empty
        }
        const selectElement = document.querySelector('select[name="FK_Location_ID"]');
        const selectedText = selectElement.options[selectElement.selectedIndex].text;
        const existingRecordIndex = tableData.findIndex(location => String(location.Depots) === String(formData.FK_Location_ID));
        if (existingRecordIndex !== -1) {


            const newPending = parseFloat(tableData[existingRecordIndex].Quantity) + parseFloat(formData.dec_Quantity);

            const updatedRecord = {
                ...tableData[existingRecordIndex], // Keep other properties as they are
                Location: formData.vc_BayName,
                DepotName: selectedText,
                Quantity: newPending.toFixed(2),
                //  Pending: "0.00"
            };

            // Create a new array with the updated record
            const updatedTableData = [
                ...tableData.slice(0, existingRecordIndex),
                updatedRecord,
                ...tableData.slice(existingRecordIndex + 1)
            ];

            // Update the state with the new table data
            setTableData(updatedTableData);
        } else {
            // Add a new record if it doesn't exist
            const newRecord = {
                ID: 0,
                Depots: formData.FK_Location_ID,
                Location: formData.vc_BayName,
                DepotName: selectedText,
                Quantity: formData.dec_Quantity,
                Pending: "0.00"
            };

            // Append the new record to the table data
            setTableData([...tableData, newRecord]);
        }

        setFormData({
            ...formData,
            FK_Location_ID: "0",
            vc_BayName: "",
            dec_Quantity: 0
        })
    };

    const handleRemoveButtonClick = async (id, pending, quantity, allocated) => {

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        if (id > 0) {
            if (parseFloat(quantity) > 0 || parseFloat(allocated) > 0) {
                Swal.fire(
                    'Error!',
                    'The record cannot be deleted if there is any quantity in stock.',
                    'warning'
                );
                return;
            }
        }
        else {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const updatedTableData = tableData.filter(record => record.ID !== id);
                        setTableData(updatedTableData);
                        if (id > 0) {

                            await PartService.DeleteStockLocation(redirectCallback, id);
                        }
                        Swal.fire(
                            'Deleted!',
                            'Your record has been deleted.',
                            'success'
                        );
                    } catch (error) {
                        console.error('Error deleting job:', error);
                        Swal.fire(
                            'Error!',
                            'There was a problem deleting the record.',
                            'error'
                        );
                    }
                }
            });
        }
    };

    const HelpLink = localStorage.getItem('HelpLink');
    const getUnitName = (unitId) => {
        const unit = unitOfMeasureList.find((unit) => unit.ID === unitId);
        return unit ? unit.Measurment : '';
    };

    const selectedSaleUnit = getUnitName(parseInt(formData.FK_UnitOfMeasure_ID_Sales));
    const selectedPurchaseUnit = getUnitName(parseInt(formData.FK_UnitOfMeasure_ID_Purchasing));

    const conversionText = !unitsAreSame
        ? `1 ${selectedPurchaseUnit} for ${formData.dec_conversion} ${selectedSaleUnit}`
        : '';


    const resetForm = () => {
        debugger;
        setFormData({
            ID: 0,
            vc_StockCode: '',
            snt_ItemType: 0,
            vc_Description: '',
            StockType: 1,
            dec_UnitWeight: '0.000',
            dec_MinimumQuantity: '0',
            dec_MaximumQuantity: '999999999',
            mon_SalesPrice: '0.00',
            mon_StockPrice: '0.00',
            mon_LastPurchasePrice: '0.00',
            vc_UnitOfSale: '0',
            vc_Manufacturer: '',
            vc_Barcode: '',
            vc_ManufacturerCode: '',
            bit_BatchManagement: '0', // Change initial state to null
            dec_Density: '1.000',
            snt_SerialTracking: '0', // Change initial state to null
            FK_UnitOfMeasure_ID_Sales: '0',
            FK_UnitOfMeasure_ID_Purchasing: '0',
            ProductBuild: '0', // Change initial state to null
            dec_conversion: '',
            dec_MinimumQuantityDepot: '0.00',
            dec_MaximumQuantityDepot: '0.00',

        });
    };
    const handleCurrencyChange = ({ symbol, value }) => {
        setCurrencySymbol1(symbol);
        setCurrencyValue1(value);
    };
    const handleCostCurrencyChange = ({ symbol, value }) => {
        setCostCurrencySymbol1(symbol);
        setCostCurrencyValue1(value);
    };

    const [imageData, setImageData] = useState(null);
    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    const [error, setError] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    const [showPdfModal, setShowPdfModal] = useState(false);
    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }
                debugger;
                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);
    const generatePDF = async (event) => {
        event.stopPropagation();

        try {

            const blob = await getMergedPDFBlob({
                moduleId: "4",
                navigate,
                currentInputValues: {
                    ID: StockID
                },
                defaultReportID: 122,
                setReportLink,
                setReportTitle,
                setError
            });

            const finalUrl = URL.createObjectURL(blob);

            setPdfUrl(finalUrl);
            setShowPdfModal(true);



        } catch (err) {
            console.error(err);
        }
    };
   
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    const defaultColumns = [
        "DepotName",
        "Location",
        "Quantity",
        "Pending",
        "dec_Allocated"
    ];
    const defaultColumnsForSearch = [
        "DepotName",
        "Location",
        "Quantity",
        "Pending",
        "dec_Allocated"

    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnOptions = [
        { value: "DepotName", label: "DepotName" },
        { value: "Location", label: "Location" },
        { value: "Quantity", label: "Quantity" },
        { value: "Pending", label: "Pending" },
        { value: "dec_Allocated", label: "dec_Allocated" }

    ];
    const columnSearchOptions = [
        { value: "DepotName", label: "DepotName" },
        { value: "Location", label: "Location" },
        { value: "Quantity", label: "Quantity" },
        { value: "Pending", label: "Pending" },
        { value: "dec_Allocated", label: "dec_Allocated" }

    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`StockLocColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`StockLocColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {

        setCurrentPage(1); // Reset to first page
        debugger;

        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";

        setSearchOptions(columnsToSearch);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const locationData = await PartService.GetPartLocation(redirectCallback, StockID, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setStockLocation(locationData);

    };
    const handleSort = async (key) => {

        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);
        //   const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const query = searchQuery.toLowerCase();
        const locationData = PartService.GetPartLocation(redirectCallback, StockID, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setStockLocation(locationData);

    };
    return (

        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            {showPartMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Part code is already exist.

                </div>
            )}
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                    <div className="col-sm-6" >
                        <div className="row mb-3">
                            <label htmlFor="StockType" className="col-sm-3 col-form-label">Type <span style={{ "color": "red" }}>*</span></label>
                            <div className="col-sm-9">
                                <select name="StockType" className='form-control' value={formData.StockType} onChange={handleFieldChange}>
                                    <option value="1">Stock Item</option>
                                    <option value="0">Non Stock Item</option>
                                </select>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="vc_StockCode" className="col-sm-3 col-form-label">Part Code <span style={{ "color": "red" }}>*</span></label>
                            <div className="col-sm-9">
                                <input type="hidden" name="PK_Stock_ID" value={formData.PK_Stock_ID} onChange={handleFieldChange} />


                                <input type="text" className="form-control" name="vc_StockCode" value={formData.vc_StockCode}
                                    onChange={handleFieldChange}
                                    readOnly={StockID > 0}
                                />
                                {errors.vc_StockCode && <div style={{ color: 'red' }}>{errors.vc_StockCode}</div>}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="vc_Description" className="col-sm-3 col-form-label">Description <span style={{ "color": "red" }}>*</span></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" name="vc_Description" value={formData.vc_Description} onChange={handleFieldChange} />
                                {errors.vc_Description && <div style={{ color: 'red' }}>{errors.vc_Description}</div>}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="mon_StockPrice" className="col-sm-3 col-form-label">Cost Price</label>
                            <div className="col-sm-4">

                                <CurrencyTextField initialCurrencySymbol={currencyCostSymbol1} initialCurrencyValue={currencyCostValue1} onCurrencyChange={handleCostCurrencyChange} currencyList={currencyList} />

                            </div>

                        </div>
                        <div className="row mb-3">

                            <label htmlFor="vc_UnitOfSale" className="col-sm-3 col-form-label">Unit of Sale</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" name="vc_UnitOfSale" value={formData.vc_UnitOfSale} onChange={handleFieldChange} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <label htmlFor="dec_Density" className="col-sm-3 col-form-label">Density</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" name="dec_Density" value={formData.dec_Density} onChange={handleFieldChange} />
                            </div>

                        </div>

                        <div className="row mb-3">

                            <label htmlFor="mon_SalesPrice" className="col-sm-3 col-form-label">Sale Price</label>
                            <div className="col-sm-4">

                                <CurrencyTextField initialCurrencySymbol={currencySymbol1} initialCurrencyValue={currencyValue1} onCurrencyChange={handleCurrencyChange} currencyList={currencyList} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <label htmlFor="vc_Manufacturer" className="col-sm-3 col-form-label">Manufacturer</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" name="vc_Manufacturer" value={formData.vc_Manufacturer} onChange={handleFieldChange} />
                            </div>

                        </div>
                        <div className="row mb-3">
                            <label htmlFor="vc_ManufacturerCode" className="col-sm-3 col-form-label">Manufacturer Code</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" name="vc_ManufacturerCode" value={formData.vc_ManufacturerCode} onChange={handleFieldChange} />
                            </div>

                        </div>
                        <div className="row mb-3">

                            <label htmlFor="dec_UnitWeight" className="col-sm-3 col-form-label">Weight</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" name="dec_UnitWeight" value={formData.dec_UnitWeight} onChange={handleFieldChange} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="vc_Barcode" className="col-sm-3 col-form-label">Barcode</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" name="vc_Barcode" value={formData.vc_Barcode} onChange={handleFieldChange} />
                            </div>

                        </div>

                        <>
                            <div className="row mb-3">
                                <label htmlFor="dec_MinimumQuantity" className="col-sm-3 col-form-label">Min Stock Level</label>
                                <div className="col-sm-4">
                                    <input type="text" className="form-control" name="dec_MinimumQuantity" value={formData.dec_MinimumQuantity} onChange={handleFieldChange} disabled={formData.StockType.toString() === "0"} />
                                </div>

                            </div>

                            <div className="row mb-3">

                                <label htmlFor="dec_MaximumQuantity" className="col-sm-3 col-form-label">Max Stock Level</label>
                                <div className="col-sm-4">
                                    <input type="text" className="form-control" name="dec_MaximumQuantity" value={formData.dec_MaximumQuantity} onChange={handleFieldChange} disabled={formData.StockType.toString() === "0"} />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="FK_UnitOfMeasure_ID_Sales" className="col-sm-3 col-form-label">Sales Unit:<span style={{ "color": "red" }}>*</span></label>
                                <div className="col-sm-5">
                                    <select name="FK_UnitOfMeasure_ID_Sales" className='form-control' value={formData.FK_UnitOfMeasure_ID_Sales} onChange={handleFieldChange} disabled={tableData.length > 0 || formData.StockType.toString() === "0"}>
                                        <option value="0">Select Sale Unit</option>
                                        {unitOfMeasureList.map((unit) => (
                                            <option key={unit.ID} value={unit.ID}>
                                                {unit.Measurment}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_UnitOfMeasure_ID_Sales && <div style={{ color: 'red' }}>{errors.FK_UnitOfMeasure_ID_Sales}</div>}
                                </div>
                                {!unitsAreSame && (
                                    <>
                                        <label htmlFor="dec_conversion" className="col-sm-2 col-form-label">Conversion</label>
                                        <div className="col-sm-2">
                                            <input type="text" className="form-control" name="dec_conversion" value={formData.dec_conversion} onChange={handleFieldChange} disabled={formData.StockType.toString() === "0"} />
                                            {errors.dec_conversion && <div style={{ color: 'red' }}>{errors.dec_conversion}</div>}
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="row mb-3" >
                                <label htmlFor="FK_UnitOfMeasure_ID_Purchasing" className="col-sm-3 col-form-label">Purchase Unit:<span style={{ "color": "red" }}>*</span></label>
                                <div className="col-sm-5">
                                    <select name="FK_UnitOfMeasure_ID_Purchasing" className='form-control' value={formData.FK_UnitOfMeasure_ID_Purchasing} onChange={handleFieldChange} disabled={tableData.length > 0 || formData.StockType.toString() === "0"}>
                                        <option value="0">Select Purchase Unit</option>
                                        {unitOfMeasureList.map((unit) => (
                                            <option key={unit.ID} value={unit.ID}>
                                                {unit.Measurment}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_UnitOfMeasure_ID_Purchasing && <div style={{ color: 'red' }}>{errors.FK_UnitOfMeasure_ID_Purchasing}</div>}

                                </div>
                                <div className="col-sm-4">
                                    <span>{conversionText}</span>
                                </div>
                            </div>

                            {shoewSerialRadio && (
                                <div className="row mb-3">
                                    <label htmlFor="Description" className="col-sm-3 col-form-label">Serial Numbering</label>
                                    <div className="col-sm-2">
                                        <div>
                                            <input className="form-check-input" type="radio" name="snt_SerialTracking" value="0" checked={formData.snt_SerialTracking === '0'} onChange={handleRadioChange} disabled={StockID > 0 || formData.StockType.toString() === "0"} />
                                        </div>
                                        <div style={{ "marginLeft": "15px" }}>
                                            <label className="col-form-label">No</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div>
                                            <input className="form-check-input" type="radio" name="snt_SerialTracking" value="2" checked={formData.snt_SerialTracking === '2'} onChange={handleRadioChange} disabled={StockID > 0 || formData.StockType.toString() === "0"} />
                                        </div>
                                        <div style={{ "marginLeft": "15px" }}>
                                            <label className="col-form-label">Yes</label>
                                        </div>
                                    </div>


                                </div>
                            )}

                            {showBatchRadio && (
                                <div className="row mb-3">
                                    <label htmlFor="Description" className="col-sm-3 col-form-label">Batch Management</label>
                                    <div className="col-sm-2">
                                        <div>
                                            <input className="form-check-input" type="radio" name="bit_BatchManagement" value="0" checked={formData.bit_BatchManagement === '0'} onChange={handleRadioChange} disabled={StockID > 0 || formData.StockType.toString() === "0"} />
                                        </div>
                                        <div style={{ "marginLeft": "15px" }}>
                                            <label className="col-form-label">Disabled</label>
                                        </div>
                                    </div>

                                    <div className="col-sm-2">
                                        <div>
                                            <input className="form-check-input" type="radio" name="bit_BatchManagement" value="1" checked={formData.bit_BatchManagement === '1'} onChange={handleRadioChange} disabled={StockID > 0 || formData.StockType.toString() === "0"} />
                                        </div>
                                        <div style={{ "marginLeft": "15px" }}>
                                            <label className="col-form-label">Enabled</label>
                                        </div>
                                    </div>

                                </div>
                            )}
                        </>

                        {KeyNameList.length > 0 && (
                            <>
                                <LeadUserDefineFieldsSection
                                    KeyNameList={KeyNameList}
                                    formData={formData}
                                    errors={errors}
                                    handleInputChange={handleFieldChange}
                                    handleDecimalChange={handleDecimalChange}
                                    handleIntegerChange={handleIntegerChange}
                                    handleFileChange={handleFileChange}
                                />
                            </>
                        )}
                    </div>

                    <div className="col-sm-6" style={{ "marginLeft": "0px" }}>
                        <div className="row mb-3">
                            <div className="col-sm-12" style={{ "textAlign": "right" }}>


                            </div>
                        </div>

                        <>
                            <div className="row mb-3">
                                <label htmlFor="FK_Location_ID" className="col-sm-2 col-form-label">Depots</label>
                                <div className="col-sm-6">
                                    <select name="FK_Location_ID" className='form-control' value={formData.FK_Location_ID} onChange={handleFieldChange} disabled={formData.StockType.toString() === "0"}>
                                        <option value="0">Select Depots</option>
                                        {LocationList.map((location) => (
                                            <option key={location.PK_Location_ID} value={location.PK_Location_ID}>
                                                {location.vc_Name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                            </div>

                            <div className="row mb-3">
                                <label htmlFor="vc_BayName" className="col-sm-2 col-form-label">Location</label>
                                <div className="col-sm-6">
                                    <input type="text" className="form-control" name="vc_BayName" value={formData.vc_BayName} onChange={handleFieldChange} disabled={formData.StockType.toString() === "0"} />
                                </div>

                            </div>
                            <div className="row mb-3">
                                <label htmlFor="dec_Quantity" className="col-sm-2 col-form-label">Quantity</label>
                                <div className="col-sm-6">
                                    <input type="text" className="form-control" name="dec_Quantity" value={formData.dec_Quantity} onChange={handleFieldChange} disabled={formData.StockType.toString() === "0"} />
                                </div>

                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2"></div>
                                <div className="col-sm-4">
                                    <button type="button" className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleAddButtonClick} disabled={formData.StockType.toString() === "0"}>
                                        <i className="icofont-plus" aria-hidden="true"> Add Stock</i>
                                    </button>
                                </div>
                            </div>
                            <div className="row mb-3">


                                <div className="col-sm-9">
                                </div>
                                <div className="col-sm-3 d-flex justify-content-end">
                                    <input
                                        list="recent-searches"
                                        type="text"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="form-control me-2"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleSearchButtonClick(e);
                                            }
                                        }}
                                    />

                                    <button type='button' onClick={handleSearchButtonClick} style={{ background: "none", border: "none" }}>
                                        <img src="assets/img/resources/search.png" alt="Add icon" />
                                    </button>
                                </div>



                            </div>
                            <div className="row mb-3" style={{ marginRight: "-5px" }}>

                                <div className='divTable'>
                                    <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ "display": "none" }}>Depots</th>
                                                <th onClick={() => handleSort('DepotName')}>Depot</th>
                                                <th onClick={() => handleSort('Location')}>Location</th>
                                                <th onClick={() => handleSort('Quantity')}>Pending</th>
                                                <th onClick={() => handleSort('Pending')}>Quantity</th>
                                                <th onClick={() => handleSort('dec_Allocated')}>Allocated</th>
                                                <th style={{ "textAlign": "right" }}> Actions</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div style={{ maxHeight: "120px", minHeight: "120px", overflow: "auto" }}>
                                        <table class="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>

                                            <tbody>
                                                {tableData.map((record) => (
                                                    <tr key={record.ID}>
                                                        <td className="no-wrap" style={{ "display": "none" }}>{record.Depots}</td>
                                                        <td className="no-wrap">{record.DepotName}</td>
                                                        <td className="no-wrap">

                                                            {record.Location && record.Location.length > 15
                                                                ? `${record.Location.substring(0, 15)}...`
                                                                : record.Location}
                                                        </td>

                                                        <td className="">{record.Quantity !== null ? record.Quantity : "0"}</td>
                                                        <td className="">{record.Pending !== null ? record.Pending : "0"}</td>
                                                        <td className="">{record.dec_Allocated !== null ? record.dec_Allocated : "0"}</td>
                                                        <td className="no-wrap" style={{ "textAlign": "right" }}>
                                                            <button type="button" style={{ "background": "none", "border": "none" }} className={`text-danger ${parseInt(isLock) > 0 ? 'disabled' : ''}`} disabled={parseInt(isLock) > 0 || formData.StockType.toString() === "0"} onClick={() => handleRemoveButtonClick(record.ID, record.Quantity, record.Pending, record.dec_Allocated)}>
                                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </>


                    </div>

                </div>
                <div className="row mb-3" >
                    <div className="col-sm-4">

                    </div>


                    <div className="col-sm-8" style={{ "float": "right" }}>

                        <button onClick={() => onClose(isChanged)} type="button" className={`btn btn-danger`} style={{ float: "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                        </button>
                        <button type="submit" className={`btn btn-primary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} disabled={parseInt(isLock) > 0}
                            style={{ float: "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                            {StockID > 0 ? ' Update' : ' Save'}

                        </button>
                        <button style={{ "marginLeft": "5px", float: "right", }} type="button" className="btn btn-secondary" onClick={generatePDF}>
                            <img src="assets/img/resources/printer-icon.png" alt="Add icon" style={{ height: "10px" }} />  Print
                        </button>

                    </div>
                </div>
            </form >




            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}


        </div >


    );
}
export default CreatePart;

